<script lang="ts">
  interface Props {
    hidden: boolean;
    direction: "left" | "right";
    size?: "25" | "50";
    onclick: () => void;
  }

  let { hidden, direction, size, onclick }: Props = $props();

  let removed = $state(hidden);

  let timer: number;
  $effect(() => {
    if (hidden) {
      timer = window.setTimeout(() => {
        removed = true;
      }, 1000);
    } else {
      removed = false;
    }

    return () => clearTimeout(timer);
  });
</script>

<oc-icon-button-v3
  class={`arrow-button arrow-button--${direction} arrow-button--size-${size}`}
  class:arrow-button--hidden={hidden}
  class:arrow-button--removed={removed}
  icon={`arrow-${direction}`}
  {onclick}
  role="none"
  {size}
  oc-aria-label=""
  elevation-level="above"
  disabled={removed}
></oc-icon-button-v3>

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;
  :global {
    .arrow-button {
      --background-color: #{tokens.$oc-semantic-color-background-above};
      display: block;
      position: absolute;
      top: calc(
        var(--arrow-button-position) - #{tokens.$oc-component-icon-button-50-background-size} / 2
      );

      &--size-25 {
        top: calc(
          var(--arrow-button-position) - #{tokens.$oc-component-icon-button-25-background-size} / 2
        );
        &.arrow-button--left {
          left: 4px;
        }

        &.arrow-button--right {
          right: 4px;
        }
      }

      &--hidden {
        display: none;
      }

      &--removed {
        display: none;
      }

      &--left {
        left: 8px;
      }

      &--right {
        right: 8px;
      }
    }
  }
</style>
